"use client"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { ProjectSelector } from "@/components/project/ProjectSelector"
import { TagInput } from "@/components/ui/tag-input"
import { useTranslation } from "react-i18next";

interface EditDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onEdit: () => void
  newLabel: string
  setNewLabel: (label: string) => void
  selectedProjectId?: string | null
  onProjectSelect?: (projectId: string | null) => void
  tags?: string[]
  onTagsChange?: (tags: string[]) => void
}

export function EditDialog({ 
  isOpen, 
  onOpenChange, 
  onEdit, 
  newLabel, 
  setNewLabel,
  selectedProjectId,
  onProjectSelect,
  tags = [],
  onTagsChange
}: EditDialogProps) {
  const { t, i18n } = useTranslation("common");

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={i18n.language === "ar" ? "rtl" : ""}
        style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
      >
        <DialogHeader>
          <DialogTitle
            className={i18n.language === "ar" ? "text-right" : "text-left"}
          >
            {t("editDialog.title")}
          </DialogTitle>
          <DialogDescription
            className={i18n.language === "ar" ? "text-right" : "text-left"}
          >
            {t("editDialog.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="label">{t("editDialog.nameLabel")}</Label>
            <Input
              id="label"
              value={newLabel}
              onChange={(e) => setNewLabel(e.target.value)}
              dir={i18n.language === "ar" ? "rtl" : "ltr"}
            />
          </div>
            {onProjectSelect && (
            <div onFocus={(e) => e.stopPropagation()}>
              <ProjectSelector
                selectedProjectId={selectedProjectId}
                onProjectSelect={onProjectSelect}
                showCreateButton={true}
              />
            </div>
          )}

          {onTagsChange && (
            <div className="grid gap-2">
              <Label>{t("editDialog.tagsLabel")}</Label>
              <TagInput
                tags={tags}
                onTagsChange={onTagsChange}
                placeholder={t("editDialog.tagsPlaceholder")}
                maxTags={10}
              />
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("buttons.cancel")}
          </Button>
          <Button onClick={onEdit}>{t("buttons.saveChanges")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

